import { Txt } from '@vst/beam';

import { DroppedAddOns } from '@mfe/shared/schema-types';

import DroppedAddonIcon from './DroppedAddonIcon';

import styles from './OptionalServiceWarning.module.scss';

const DroppedAddons = ({ droppedAddOns }: { droppedAddOns: DroppedAddOns[] }): JSX.Element => {
  return (
    <div className={styles['text-icon-container']} data-cy="dropped-addons-container">
      {droppedAddOns.map(({ name, productTypeId }) => (
        <div key={productTypeId} data-cy="IconsWithNames" className={styles['text-icon']}>
          <DroppedAddonIcon productTypeId={productTypeId} />
          <Txt pl={'8px'} variant={'bodyLargeBold'}>
            {name}
          </Txt>
        </div>
      ))}
    </div>
  );
};

export default DroppedAddons;
